module.exports = __webpack_public_path__ + "img/Feature.37d3dde3.jpg";